// extracted by mini-css-extract-plugin
export var content = "_9z-3";
export var list = "_9z-4";
export var settingsContent = "_9z-7";
export var settingsPanel = "_9z-8";
export var state = "_9z-6";
export var triggerBadge = "_9z-2";
export var triggerButton = "_9z-1";
export var triggerShell = "_9z-0";
export var unreadDot = "_9z-5";